/*                                                                           */

import { DEV } from 'esm-env';

/**
 *
 *
 */
export function invalid_default_snippet() {
	if (DEV) {
		const error = new Error(`invalid_default_snippet\nCannot use \`{@render children(...)}\` if the parent component uses \`let:\` directives. Consider using a named snippet instead\nhttps:/*                                     */

		error.name = 'Svelte error';
		throw error;
	} else {
		throw new Error(`https:/*                                     */
	}
}

/**
 *
 *
 *
 */
export function lifecycle_outside_component(name) {
	if (DEV) {
		const error = new Error(`lifecycle_outside_component\n\`${name}(...)\` can only be used during component initialisation\nhttps:/*                                         */

		error.name = 'Svelte error';
		throw error;
	} else {
		throw new Error(`https:/*                                         */
	}
}

/**
 *
 *
 *
 */
export function store_invalid_shape(name) {
	if (DEV) {
		const error = new Error(`store_invalid_shape\n\`${name}\` is not a store with a \`subscribe\` method\nhttps:/*                                 */

		error.name = 'Svelte error';
		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 */
export function svelte_element_invalid_this_value() {
	if (DEV) {
		const error = new Error(`svelte_element_invalid_this_value\nThe \`this\` prop on \`<svelte:element>\` must be a string, if defined\nhttps:/*                                               */

		error.name = 'Svelte error';
		throw error;
	} else {
		throw new Error(`https:/*                                               */
	}
}